import React, { useEffect } from 'react'
import { Footer } from '../components/footer';
import Aos from "aos";
import { useGetCms } from './home/api/api';

const TermsconditionsPage = () => {
    const { data: getCms } = useGetCms()
    useEffect(() => {
        window.scrollTo(0, 0);
        Aos.init({ once: true });
    }, []);
    return (
        <>
            <div className='mainContent'>
                <div className="pageContent py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="cmsTitlecnt text-center mb-4">
                                    <h3>Terms & Conditions</h3>
                                    <p>It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                                </div>

                                <div className="cmscontent">
                                    
                                    <div className='cmsPara' dangerouslySetInnerHTML={{ __html: getCms?.data[0]?.content }} />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default TermsconditionsPage;